export const mapScales = {
    INITIAL_SCALE: 0.25,
    SCALE_STEPPER: 0.25,
    MIN_SCALE: 0.25,
    STANDARD_SCALE: 1,
    MAX_SCALE: 2,
    STATION_DESCRIPTION_DEFAULT_VISIBILITY_SCALE: 0.75,
    SEARCH_AUTO_ZOOM_MIN_SCALE: 0.6,
    CURRENT_LOCATION_ZOOM_SCALE: 0.75
};

export const getMapInitialScale = (isMapTour: boolean) => {
    return isMapTour ? mapScales.STANDARD_SCALE : mapScales.INITIAL_SCALE;
};
